import * as types from '../constants/ActionTypes';
import initialState from './initialState';

export default function(state = initialState.autorizacionViaje, action) {
  switch (action.type) {
    case types.SET_AUTORIZACION_VIAJE:
      return {
        ...state,
        ...action.payload.autorizacion,
      };

    case types.REINICIAR:
      return initialState.autorizacionViaje;

    default:
      return state;
  }
}
